// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ugQL","label":"styles_label__2fGuh"};